export default {
  messageTemplateSms: null,
  messageTemplateLine: null,
  imageRelativePath: null,
  imageRelativePathUrl: null,
  targetUrl: null,
  previewImageRelativePath: null,
  previewImageRelativePathUrl: null,
  videoRelativePath: null,
  videoRelativePathUrl: null,
  messageTemplatePushNoti: null,
  pushNotiTargetUrl: null,
  showInInbox: false,
  messageTitle: null,
};
